import { ESize } from 'src/styles/theme/utils/enums';
import { addTransition, getThemeColor } from 'src/styles/theme/utils/functions';
import styled, { css } from 'styled-components';

export const StyledNGIconButton = styled.button<{
	size?: '2xs' | ESize.s | ESize.m | ESize.l;
	fullWidth?: boolean;
	isHidden?: boolean;
	isActive?: boolean;
	customOpacity?: number;
}>`
	${(p) => {
		return css`
			position: relative;
			border: none;
			background-color: transparent;
			padding: 0;

			${!p.disabled && !p.isHidden ? `cursor: pointer;` : ''}
			${p.fullWidth ? `width: 100%;` : ''}
			${p.customOpacity ? `opacity: ${p.customOpacity};` : ''}
      ${p.isHidden ? `opacity: 0;` : ''}

			${addTransition()}

			${() => {
				switch (p.size) {
					case ESize['2xs']:
						return `
          padding: 2px 8px;
        `;
					case ESize.s:
						return `
          padding: 4px 24px;
        `;
					case ESize.m:
						return `
          padding: 15px 24px;

					& > span {
						font-size: 24px;
					}
        `;
					case ESize.l:
						return `
          padding: 10px 24px;
        `;
					default:
						return `
          padding: 8px 24px;
        `;
				}
			}}

			& > span {
				text-align: center;
				display: flex;
				align-items: center;
			}

			&::before {
				content: ' ';
				position: absolute;
				top: 0;
				right: 0;
				bottom: 0;
				z-index: -1;

				${addTransition()}

				${() => {
					if (!p.gradientColor) {
						return '';
					}

					return css`
						${!p.isActive ? `width: 0%;` : 'width: 100%;'}
						background-image: linear-gradient(270deg, ${getThemeColor(p.theme, p.gradientColor)} 0%, #00000000 100%);
					`;
				}}
			}

			${p.disabled ? 'opacity: 0.5;' : ''}
		`;
	}}
`;
